import { useList } from '../../../api/react-query';

interface Props {
  params: {
    statuses?: string[];
    date?: Date;
  };
}

const useListLetters = ({ params }: Props) => {
  const { data, isLoading, refetch, isFetching, isRefetching } = useList(
    'letter-generation/employees/letter-requests',
    { ...params },
  );

  return {
    data: data?.data?.data,
    count: data?.data?.total,
    isLoading: isLoading || isFetching || isRefetching,
    refetch,
  };
};

export { useListLetters };
